import { getIsDarkTheme } from '../selectors/getIsDarkTheme';
import { NEUTRAL_DARK_THEME_PALETTE } from '../constants/neutralDarkThemePalette';
import { NEUTRAL_LIGHT_THEME_PALETTE } from '../constants/neutralLightThemePalette';
import type { NeutralPalette } from '../schema/MiniPalette';

export const getRawNeutralPalette = (isDarkTheme: boolean = getIsDarkTheme()): NeutralPalette => {
    return isDarkTheme ? NEUTRAL_DARK_THEME_PALETTE : NEUTRAL_LIGHT_THEME_PALETTE;
};
